import * as actions from "store/actions";

const initialState = {
    unmodifiedEmailTemplates: {},
    editor: {
        id: "",
        name: "",
        subject: "",
        body: "",
    },
};

const WebchatEmailTemplatesReducer = (state = initialState, action) => {
    switch (action.type) {
        case actions.EMAIL_TEMPLATES_FETCHED_FROM_SERVER:
            const sortedTemplates = action.payload.response.data[0].slice().sort((a, b) => a.id - b.id);
            const objectFromMap = new Map(sortedTemplates.map(obj => [obj.id, obj]));
            const objectMap = Object.fromEntries(objectFromMap);
            return {
                ...state,
                unmodifiedEmailTemplates: objectMap,
            };
        case actions.EMAIL_TEMPLATE_SAVED_TO_SERVER:
            return {
                ...state,
                unmodifiedEmailTemplates: {
                    ...state.unmodifiedEmailTemplates,
                    [action.payload.templateId]: action.payload.templateBody,
                },
            };
        case actions.EMAIL_TEMPLATES_INITIAL_FETCH_COMPLETED:
            const firstObjectInMap = Object.entries(state.unmodifiedEmailTemplates)[0] || initialState.editor;
            const firstFoundTemplate = firstObjectInMap[1] || initialState.editor;
            return {
                ...state,
                editor: firstFoundTemplate,
            };
        case actions.EMAIL_TEMPLATE_SELECTED_IN_TAB_MENU:
            const templateId = action.payload
            return {
                ...state,
                editor: state.unmodifiedEmailTemplates[templateId] || initialState.editor,
            };
        case actions.EDITOR_BODY_MODIFIED:
            return {
                ...state,
                editor: {
                    ...state.editor,
                    body: action.payload,
                },
            };
        case actions.RESET:
            return {
                initialState
            };
        default:
            return state;
    }
};

export default WebchatEmailTemplatesReducer;
